// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const tableClasses = {
  actionBar: "qui-table__action-bar",
  body: "qui-table__body",
  cell: "qui-table__cell",
  cellAction: "qui-table__cell-action",
  columnDropIndicator: "qui-table__column-drop-indicator",
  columnFilterAction: "qui-table__column-filter-action",
  columnHeaderAction: "qui-table__column-header-action",
  columnResizer: "qui-table__column-resizer",
  columnResizerOverlay: "qui-table__column-resizer-overlay",
  columnSortAction: "qui-table__column-sort-action",
  dragHandle: "qui-table__drag-handle",
  dragPreview: "qui-table__drag-preview",
  footer: "qui-table__footer",
  header: "qui-table__header",
  headerCell: "qui-table__header-cell",
  pagination: "qui-table__pagination",
  root: "qui-table__root",
  row: "qui-table__row",
  rowDropIndicator: "qui-table__row-drop-indicator",
  rowExpandButton: "qui-table__row-expand-button",
  rowSelectionIndicator: "qui-table__row-selection-indicator",
  scrollContainer: "qui-table__scroll-container",
  table: "qui-table__table",
  titleBar: "qui-table__title-bar",
} as const
